import React from "react";
import "./WarningList.css";
import Warning from "./Warning";
import "./WarningList.css";
import { Icon } from "semantic-ui-react";

const WarningList = ({
  hasWarnings,
  warnings,
  infoBarHeight,
  boxID,
  orderCompletition,
  orderChecked,
}) => {
  console.log(hasWarnings, orderCompletition, orderChecked);
  if (!hasWarnings && boxID === -1) {
    return null;
  }
  const heightStyleContainer = { height: ` calc(100vh - ${infoBarHeight + 50}px)` };

  if ((!hasWarnings && boxID > -1 && !orderCompletition) || orderChecked) {
    return (
      <div style={heightStyleContainer} className={"warning-container"}>
        <div className="warning-header green flexRow spaceAround flexMiddle">
          <span>ORDER OK </span>
          <Icon style={{ height: "10px" }} name="check circle outline"></Icon>
        </div>
        <div className="warning-header scalable green flexible flexColumn spaceAround flexMiddle">
          Kontrollera att varorna ligger rätt
        </div>
      </div>
    );
  } else if (!hasWarnings && boxID > -1 && orderCompletition) {
    return (
      <div style={heightStyleContainer} className={"warning-container"}>
        <div className="warning-header flexRow spaceAround flexMiddle">
          <span>Manuell kontroll. </span>
        </div>
      </div>
    );
  }

  const heightStyleList = { height: ` calc(100vh - ${infoBarHeight + 60 + 50}px)` };

  const cards = warnings.map((warning, index) => {
    return <Warning key={index} warning={warning}></Warning>;
  });

  return (
    <div style={heightStyleContainer} className={"warning-container"}>
      <div className="warning-header flexColumn spaceAround flexMiddle">Manuell kontroll</div>
      <div style={heightStyleList} className="warning-list flexColumn">
        {cards}
      </div>
    </div>
  );
};

WarningList.propTypes = {};

export default WarningList;
